import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { globals } from 'src/app/globals';
import { ToastService } from '../../services/toast.service';
import { userService } from '../../services/user.service';
import * as FileSaver from "file-saver";

@Component({
  selector: 'app-companies',
  templateUrl: './companies.page.html',
  styleUrls: ['./companies.page.scss'],
})
export class CompaniesPage implements OnInit {

  user: any = {};
  state: any = 1;
  companies: any = {};
  logHoursModal: any = false;
  logBulkHours: any = {
    companies: {}
  };
  logTypes: any = {};
  sort: any = 1;
  build: any = {};
  company: any = {};
  search: any = {};
  status: any = {};
  users: any = {};
  kanbanView: any = 1;

  constructor(
    public userService: userService,
    private router: Router,
    private toastService: ToastService,
    private http: HttpClient
  ) { }

  switchKanban() {
    if (this.kanbanView == 1) {
      this.kanbanView = 0;
    }
    else {
      this.kanbanView = 1;
    }
  }

  companyStatusCount(status: any) {
    var count = 0
    for (const company of this.companies) {
      if (company.status == status) {
        count ++;
      }
    }
    return count;
  }

  create() {
    this.state = 2;
  }
  back() {
    this.state = 1;
    this.getCompanies();
  }

  getCompanies() {

    const header = new HttpHeaders()
      .set('Content-Type', 'text/plain')

    const param = new HttpParams()
      .set('apiKey', globals.key)
      .set('apiToken', this.user.token)
      .set('apiFunctionName', 'getCompanies')

    const body = {
      cid: this.user.cid,
      id: this.user.id,
      query: this.search.query
    };

    this.http
      .post<any>(globals.api, body, { observe: 'response', params: param, headers: header })
      .subscribe(
        (response: any) => {
          if (response.body.success == true && response.body.dataArray) {
            this.companies = response.body.dataArray;
          }
          else {
            this.toastService.showToast({ header: 'Error', message: 'Oops, no results found' });
          }
        },
        (error: any) => {
          this.toastService.showToast({ header: 'Error', message: 'Oops, no results found' });
        }
      );
    
  }

  favouriteCompany(x: any) {

    const header = new HttpHeaders()
      .set('Content-Type', 'text/plain')

    const param = new HttpParams()
      .set('apiKey', globals.key)
      .set('apiToken', this.user.token)
      .set('apiFunctionName', 'favouriteCompany')

    const body = {
      id: this.user.id,
      cid: x
    };

    this.http
      .post<any>(globals.api, body, { observe: 'response', params: param, headers: header })
      .subscribe(
        (response: any) => {
          this.toastService.showToast({ header: 'Success', message: 'Company favourite status updated' });
          this.getCompanies();
        },
        (error: any) => {
          this.toastService.showToast({ header: 'Error', message: 'Oops, something went wrong updating company status' });
        }
      );
    
  }

  getStatus() {

    const header = new HttpHeaders()
    .set('Content-Type', 'text/plain')

    const param = new HttpParams()
      .set('apiKey', globals.key)
      .set('apiToken', this.user.token)
      .set('apiFunctionName', 'getCompanyStatus')

    const body = this.user;

    this.http
      .post<any>(globals.api, body, { observe: 'response', params: param, headers: header })
      .subscribe(
        (response: any) => {
          if (response.body.success == true && response.body.dataArray) {
            this.status = response.body.dataArray;
          }
          else {
            this.toastService.showToast({ header: 'Error', message: 'Oops, something went wrong getting status data' });
          }
        },
        (error: any) => {
          this.toastService.showToast({ header: 'Error', message: 'Oops, something went wrong getting status data' });
        }
      );

  }

  getUsers() {

    const header = new HttpHeaders()
    .set('Content-Type', 'text/plain')

    const param = new HttpParams()
      .set('apiKey', globals.key)
      .set('apiToken', this.user.token)
      .set('apiFunctionName', 'getUsers')

    const body = {
      id: this.user.id,
      sid: this.user.sid,
      pid: 0
    };

    this.http
      .post<any>(globals.api, body, { observe: 'response', params: param, headers: header })
      .subscribe(
        (response: any) => {
          if (response.body.success == true && response.body.dataArray) {
            this.users = response.body.dataArray;
          }
          else {
            this.toastService.showToast({ header: 'Error', message: 'Oops, something went wrong getting user data' });
          }
        },
        (error: any) => {
          this.toastService.showToast({ header: 'Error', message: 'Oops, something went wrong getting user data' });
        }
      );

  }

  getLogTypes() {

    const header = new HttpHeaders()
    .set('Content-Type', 'text/plain')

    const param = new HttpParams()
      .set('apiKey', globals.key)
      .set('apiToken', this.user.token)
      .set('apiFunctionName', 'getLogTypes')

    const body = this.user;

    this.http
      .post<any>(globals.api, body, { observe: 'response', params: param, headers: header })
      .subscribe(
        (response: any) => {
          if (response.body.success == true && response.body.dataArray) {
            this.logTypes = response.body.dataArray;
          }
          else {
            this.toastService.showToast({ header: 'Error', message: 'Oops, something went wrong getting log type data' });
          }
        },
        (error: any) => {
          this.toastService.showToast({ header: 'Error', message: 'Oops, something went wrong getting log type data' });
        }
      );

  }


  addBulkHoursCompany() {

    var selectedCompany = this.companies.find(x => x.id === this.logBulkHours.newCompany);

    if (this.logBulkHours.companies.length > 0) {
      this.logBulkHours.companies.push({
        id: this.logBulkHours.newCompany,
        name: selectedCompany.name
      })
    }
    else {
      this.logBulkHours.companies = [{
        id: this.logBulkHours.newCompany,
        name: selectedCompany.name
      }]
    }
    this.toastService.showToast({ header: 'Success', message: 'Company has been added as a support recipient' });
    this.logBulkHours.newCompany = '';

  }

  createSupportHours() {

    if (this.logBulkHours.date && this.logBulkHours.duration && this.logBulkHours.provided_by) {
      const header = new HttpHeaders()
      .set('Content-Type', 'text/plain')

      const param = new HttpParams()
        .set('apiKey', globals.key)
        .set('apiToken', this.user.token)
        .set('apiFunctionName', 'addBulkSupportHours')

      const body = {
        id: this.user.id,
        cid: this.user.cid,
        sid: this.user.sid,
        event: this.logBulkHours
      };

      this.http
        .post<any>(globals.api, body, { observe: 'response', params: param, headers: header })
        .subscribe(
          (response: any) => {
            if (response.body.success == true && response.body.insertedId > 0) {
              this.toastService.showToast({ header: 'Success', message: 'Event has been created' });
              this.logBulkHours = {
                companies: {}
              };
              this.toggleLogHours();
              this.getCompanies();
            }
            else {
              this.toastService.showToast({ header: 'Error', message: 'Oops, something went wrong creating support hours' });
            }
          },
          (error: any) => {
            this.toastService.showToast({ header: 'Error', message: 'Oops, something went wrong creating support hours' });
          }
        );
    }
    else {
      this.toastService.showToast({ header: 'Error', message: 'Support Hours must contain: Date, Duration, Provided By' });
    }

  }
  
  selectCompany(company: any) {
    this.company = company;
    this.state = 3;
  }

  refresh(event: any) {
    this.companies = {};
    this.getCompanies();
    setTimeout(() => {
      event.target.complete();
    }, 500);
  }

  calcLogHours(x: any) {
    var logHours = 0
    if (this.companies[x].logs) {
      for (const log of this.companies[x].logs) {
        logHours = logHours + (log.duration.substring(0, 2) * 60 + parseInt(log.duration.substring(3, 5)));
      }
      logHours = (logHours / 60);
    }
    this.companies[x].logHours = Number(logHours);
    return Number(logHours);
  }

  sortCompanies(x) {
    if (x == 1) {
      this.companies.sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1);
    }
    else if (x == 2) {
      this.companies.sort((a, b) => a.area_name.toLowerCase() > b.area_name.toLowerCase() ? 1 : -1);
    }
    else if (x == 3) {
      this.companies.sort((a, b) => a.contact_name.toLowerCase() > b.contact_name.toLowerCase() ? 1 : -1);
    }
    else if (x == 4) {
      this.companies.sort((a, b) => a.status_name.toLowerCase() > b.status_name.toLowerCase() ? 1 : -1);
    }
    else if (x == 5) {
      this.companies.sort((a, b) => a.project_status.toLowerCase() > b.project_status.toLowerCase() ? 1 : -1);
    }
    else if (x == 6) {
      this.companies.sort((a, b) => a.logHours > b.logHours ? 1 : -1);
    }
    else if (x == 7) {
      this.companies.sort((a, b) => a.timestr.toLowerCase() > b.timestr.toLowerCase() ? 1 : -1);
    }
    this.sort = x;
  }

  export() {

    const header = new HttpHeaders()
      .set('Content-Type', 'text/plain')

    const param = new HttpParams()
      .set('apiKey', globals.key)
      .set('apiToken', this.user.token)
      .set('apiFunctionName', 'exportCompanies')

    const body = this.user;

    this.http
      .post<any>(globals.api, body, { observe: 'response', params: param, headers: header })
      .subscribe(
        (response: any) => {
          if (response.body.success == true && response.body.dataArray) {

            var dataArray = response.body.dataArray;
            for(var i = 0; i < dataArray.length; i++) {

              if (dataArray[i].sme == 1) {
                dataArray[i].sme_name = 'No';
              }
              else if (dataArray[i].sme == 2) {
                dataArray[i].sme_name = 'Yes';
              }
              else {
                dataArray[i].sme_name = 'Not Yet Known';
              }

              if (dataArray[i].maa == 1) {
                dataArray[i].maa_name = 'Yes';
              }
              else {
                dataArray[i].maa_name = 'No';
              }

              dataArray[i].address = dataArray[i].address.replace(/,/g, '');

              if (dataArray[i].mst_user_name == 'Undefined ') {
                dataArray[i].mst_user_name = '';
              }

              if (dataArray[i].uon_user_name == 'Undefined ') {
                dataArray[i].uon_user_name = '';
              }

              var logHours = 0
              if (dataArray[i].logs) {
                for (const log of dataArray[i].logs) {
                  logHours = logHours + (log.duration.substring(0, 2) * 60 + parseInt(log.duration.substring(3, 5)));
                }
                logHours = Number(logHours / 60);
              }

              if(i == 0) {
                var rows = [];
                rows.push([
                    "Name",
                    "Address",
                    "Post Code",
                    "Reference",
                    "Contact - TM",
                    "Contact - MST",
                    "Contact - UoN",
                    "Sector",
                    "Status",
                    "Project Status",
                    "Support Hours",
                    "Area",
                    "Team",
                    "Source",
                    "SME",
                    "MAA",
                    //"Description",
                    "Contact Name",
                    "Contact Email",
                    "Contact Phone",
                    "Contact Role"
                  ]);
              }
              rows.push([
                dataArray[i].name,
                dataArray[i].address,
                dataArray[i].address_postcode,
                dataArray[i].reference,
                dataArray[i].contact_name,
                dataArray[i].mst_user_name,
                dataArray[i].uon_user_name,
                dataArray[i].sector_name,
                dataArray[i].status_name,
                dataArray[i].project_status,
                logHours.toFixed(2),
                dataArray[i].area_name,
                dataArray[i].team_name,
                dataArray[i].source_name,
                dataArray[i].sme_name,
                dataArray[i].maa_name,
                //dataArray[i].description,
                dataArray[i].company_contact_name,
                dataArray[i].company_contact_email,
                dataArray[i].company_contact_phone,
                dataArray[i].company_contact_role,
              ])
            }
            
            let csvContent = rows.map(e => e.join(",")).join("\n");
            var data = new Blob([csvContent], {type: 'text/csv;charset=utf-8'});
            FileSaver.saveAs(data, 'my-runway_companies_export.csv');
            
          }
          else {
            this.toastService.showToast({ header: 'Error', message: 'Oops, something went wrong exporting company data' });
          }
        },
        (error: any) => {
          this.toastService.showToast({ header: 'Error', message: 'Oops, something went wrong exporting company data' });
        }
      );

  }

  toggleLogHours() {
    this.logHoursModal = !this.logHoursModal;
  }

  returnZero() {
    return 0
  }

  ngOnInit() {
    this.user = this.userService.getData();
    this.build = globals;
    this.getCompanies();
    this.getUsers();
    this.getStatus();
    this.getLogTypes();
  }

}